// Helpers for the dashboard "Download as Excel Sheet" buttons, backed by
// SheetJS (xlsx). `buildAoa` is a pure array-of-arrays builder (node-testable);
// `downloadXlsx` builds a single-sheet workbook and triggers a real .xlsx
// download in the browser.
const XLSX = require("xlsx");

// Pure: worksheet matrix = header row followed by the data rows. Numbers stay
// numbers (so Excel keeps them summable); strings stay text.
function buildAoa(headers, rows) {
  return [headers].concat(rows);
}

// Browser: write the headers + rows to a one-sheet .xlsx and prompt download.
function downloadXlsx(filename, sheetName, headers, rows) {
  const ws = XLSX.utils.aoa_to_sheet(buildAoa(headers, rows));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
}

module.exports = { buildAoa, downloadXlsx };
